<template>
  <div>
    <ContentBlock style="padding: 0 10px 84px 10px;">
      <div class="topTitleContainer">
        <span>状态
          <el-radio-group v-model="outform.bizOppStatus" @change="handleSearch" style="margin-left: 14px;">
            <el-radio-button label="">全部</el-radio-button>
            <el-radio-button label="BE_BEING">进行中</el-radio-button>
            <el-radio-button label="FULL">已满额</el-radio-button>
            <el-radio-button label="FINISHED">已关单</el-radio-button>
          </el-radio-group>
        </span>
      </div>
      <TableWithPagination class="special" :columnList="columnList" :tableData="targetLists" :toolBar="toolBar" :sortInfo.sync="sortInfo" tableBorder="default" :showRightToolbar="true" :pagination.sync="pagination" @size-change="getTargetLists" @current-change="getTargetLists" @sort-change="getTargetLists" :highHoverRow="false" :highlightRow="false" :leftToolbar="tableButtons" />
    </ContentBlock>
    <el-drawer title="高级筛选" width="400" direction="rtl" :modal-append-to-body="false" :visible.sync="isShow"
      :close-on-click-modal="false" @closed="isShow = false">
      <el-form label-width="auto" label-position="right" style="margin-top: 20px;padding: 10px;">
        <el-row>
          <el-col :span='24'>
            <el-form-item label="商机号">
              <el-input placeholder="请输入商机号" v-model.trim="form.code" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span='24'>
            <el-form-item label="询价单位">
              <el-input placeholder="请输入询价单位" v-model.trim="form.inquirePriceParty" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span='24'>
            <el-form-item label="询价类型">
              <el-select v-model.trim="form.inquireSource" placeholder="请选择询价类型" clearable
                :popper-append-to-body="false">
                <el-option label="全部" value=""></el-option>
                <el-option label="平台询单" :value="1"></el-option>
                <el-option label="资管易询单" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span='24'>
            <el-form-item label="业务类型">
              <el-select v-model.trim="form.businessType" placeholder="请选择业务类型" clearable
                :popper-append-to-body="false">
                <el-option label="全部" value=""></el-option>
                <el-option label="维修" value="MAINTAIN"></el-option>
                <el-option label="备件" value="SPARE_PART"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span='24'>
            <el-form-item label="创建人">
              <el-input placeholder="请输入创建人" v-model.trim="form.createUserName" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span='24'>
            <el-form-item label="创建时间">
              <el-date-picker
                v-model="createTime"
                @change="handleChangeTime($event, 'createTime')"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span='24'>
            <el-form-item label="交付地址">
              <area-cascader-multiple
                ref="areaCascaderMultiple"
                :collapsTags="true"
                :checkStrictly="true"
                @updateBusinessArea="changeBusinessArea"
              />
            </el-form-item>
          </el-col>
          <el-col :span='24'>
            <el-form-item label="期望交期">
              <el-date-picker
                v-model="expectedDeliveryDate"
                @change="handleChangeTime($event, 'expectedDeliveryDate')"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div style="text-align: center;">
        <el-button @click="handleEmpty">清空</el-button>
        <el-button type="primary" @click="handleQuery">查询</el-button>
      </div>
    </el-drawer>

    <!-- 商机详情弹窗 -->
    <DetailDialog v-if="detailDialogVisible" :dialog-visible.sync="detailDialogVisible" :id="currentOpportunity.id" :type="currentOpportunity.businessType" :isEncryptable="!currentOpportunity.scrambleFlag" :bizOppStatus="currentOpportunity.bizOppStatus">
    </DetailDialog>
  </div>
</template>
<script>
import TableWithPagination, { TablePaginationMixin } from '@/components/common/TableWithPagination';
import { queryBizOppPageList, exportBizOpp } from '@/api/businessOpportunity';
import * as dayjs from 'dayjs';
import icRefresh from '@/assets/table/ic_refresh.svg';
import icAdvanceSearch from '@/assets/table/ic_advanceSearch.svg';
import AreaCascaderMultiple from '@/components/common/areaCascaderMultiple';
import DetailDialog from './detail/detailDialog.vue';

export default {
  name: 'SASS_GXTGL_BUSINESSOPPORTUNITY',
  components: {
    TableWithPagination,
    AreaCascaderMultiple,
    DetailDialog,
  },
  mixins: [TablePaginationMixin],
  computed: {
    tableButtons () {
      return [
        {
          name: '导出',
          status: 'primary',
          size: 'small',
          code: 'exportExcel',
          disabled: this.isLoading,
          loading: this.isLoading,
          // permission: '', // 权限码
          click: this.handleExport,
        },
      ];
    },
    toolBar () {
      let currentLists = [
        {
          type: 'custom',
          render: () => {
            return (
              <el-input placeholder='请输入商机备件/设备名称' style='width:250px;' v-model={this.outform.goodsName}>
                <el-button slot="suffix" icon="el-icon-search" onClick={this.handleSearch} style='position: absolute;height: 100%;right: -5px;top: 0;'>
                </el-button>
              </el-input>
            );
          },
        },
        {
          type: 'custom',
          render: () => {
            return (
              <vxe-button circle onClick={this.handleAdvancedSearch}>
                <img style='font-size:14px;width:15px;height:15px;' src={icAdvanceSearch} />
              </vxe-button>
            );
          },
        },
        {
          type: 'custom',
          render: () => {
            return (
              <vxe-button circle onClick={this.handleReset}>
                <img style='font-size:14px;width:15px;height:15px;' src={icRefresh} />
              </vxe-button>
            );
          },
        },
      ];
      return currentLists;
    },
    columnList () {
      const cols = [
        {
          tooltip: true,
          label: '商机号',
          minWidth: '120px',
          width: '',
          key: 'code',
          prop: 'code',
        },
        {
          tooltip: true,
          label: '商机描述',
          minWidth: '300px',
          width: '',
          key: 'inquireDesc',
          prop: 'inquireDesc',
        },
        {
          tooltip: true,
          label: '询价单位',
          minWidth: '150px',
          width: '',
          key: 'inquirePriceParty',
          prop: 'inquirePriceParty',
        },
        {
          tooltip: true,
          label: '询价类型',
          minWidth: '100px',
          width: '',
          key: 'inquireSourceDesc',
          prop: 'inquireSourceDesc',
        },
        {
          tooltip: true,
          label: '业务类型',
          minWidth: '80px',
          width: '',
          key: 'businessTypeDesc',
          prop: 'businessTypeDesc',
        },
        {
          tooltip: true,
          label: '商机状态',
          minWidth: '80px',
          width: '',
          key: 'bizOppStatusDesc',
          prop: 'bizOppStatusDesc',
        },
        {
          tooltip: true,
          label: '商机名额',
          minWidth: '80px',
          width: '',
          key: 'bizOppQuota',
          prop: 'bizOppQuota',
        },
        {
          tooltip: true,
          label: '创建人',
          minWidth: '100px',
          width: '',
          key: 'createUserName',
          prop: 'createUserName',
        },
        {
          tooltip: true,
          label: '创建时间',
          minWidth: '130px',
          width: '',
          key: 'createTime',
          prop: 'createTime',
          format: (v) => {
            return this.formatTime(v);
          },
        },
        {
          tooltip: true,
          label: '交付地址',
          minWidth: '120px',
          width: '',
          key: 'deliveryAddress',
          prop: 'deliveryAddress',
          render: (h, { row }) => {
            return row.deliveryProvinceName + row.deliveryCityName || '--';
          },
        },
        {
          tooltip: true,
          label: '期望交期',
          minWidth: '130px',
          width: '',
          key: 'expectedDeliveryDate',
          prop: 'expectedDeliveryDate',
          format: (v) => {
            return this.formatTime(v);
          },
        },
      ];

      cols.push({
        label: '操作',
        prop: 'action',
        width: '70px',
        fixed: 'right',
        render: (h, { row }) => {
          let actions = [];
          actions.push(h('span', {
            domProps: {
              className: 'table-action',
            },
            on: {
              click: () => { this.handleDetail(row); },
            },
          }, '查看'));
          return h('div', actions);
        },
      });

      return cols;
    },
  },
  data () {
    return {
      outform: {
        bizOppStatus: '',
        goodsName: '',
      },
      form: {
        businessType: '',
        code: '',
        createTimeEnd: '',
        createTimeStart: '',
        createUserName: '',
        deliveryProvinceNameOrCityNames: [],
        expectedDeliveryDateEnd: '',
        expectedDeliveryDateStart: '',
        inquirePriceParty: '',
        inquireSource: '',
      },
      createTime: '',
      expectedDeliveryDate: '',
      targetLists: [],
      isShow: false,
      isLoading: false,
      detailDialogVisible: false,
      currentOpportunity: {},
    };
  },
  methods: {
    formatTime (v) {
      let ret = '';

      if (v) {
        ret = dayjs(v * 1).format('YYYY-MM-DD HH:mm');
      }

      return ret;
    },
    handleChangeTime (v, type) {
      if (!v || v.length === 0) {
        this.form[type + 'Start'] = '';
        this.form[type + 'End'] = '';
      } else {
        this.form[type + 'Start'] = v[0] + ' 00:00:00';
        this.form[type + 'End'] = v[1] + ' 23:59:59';
      }
    },
    changeBusinessArea (arealists) {
      const labelArr = arealists.map(item => {
        let label = '';
        if (item.type === 'PROVINCE') label = item.provinceName;
        if (item.type === 'CITY') label = item.cityName;
        return label;
      });
      this.form.deliveryProvinceNameOrCityNames = [...new Set(labelArr)];
    },
    handleQuery () {
      this.pagination.currentPage = 1;

      this.getTargetLists();

      this.$nextTick(() => {
        this.isShow = false;
      });
    },
    handleSearch () {
      this.pagination.currentPage = 1;

      this.getTargetLists();
    },
    handleReset () {
      this.handleEmpty();

      this.pagination.currentPage = 1;

      this.getTargetLists();
    },
    handleEmpty () {
      this.outform = this.$options.data().outform;
      this.form = this.$options.data().form;
      this.form.deliveryProvinceNameOrCityNames = [];
      this.createTime = [];
      this.expectedDeliveryDate = [];
      if (this.$refs.areaCascaderMultiple) {
        this.$refs.areaCascaderMultiple.defaultValue = [];
      }
    },
    handleDetail (v) {
      // 查看详情弹窗
      this.currentOpportunity = v;
      this.detailDialogVisible = true;
    },
    handleExport () {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      const params = {
        ...this.form,
        ...this.outform,
        createTimeStart: new Date(this.form.createTimeStart || '').getTime() || '',
        createTimeEnd: new Date(this.form.createTimeEnd || '').getTime() || '',
        expectedDeliveryDateStart: new Date(this.form.expectedDeliveryDateStart || '').getTime() || '',
        expectedDeliveryDateEnd: new Date(this.form.expectedDeliveryDateEnd || '').getTime() || '',
        pageSize: this.pagination.pageSize,
        pageNum: this.pagination.currentPage,
      };
      if (this.sortInfo.orderByProperty && this.sortInfo.orderByType) {
        params.orderBy = [this.sortInfo];
      }
      exportBizOpp(params).then(res => {
        this.isLoading = false;
        let headerName = `商机表_${dayjs().format('YYYYMMDDHHmmss')}`;
        let fileName = decodeURI(headerName);
        let blob = new Blob([res.data], {type: 'application/vnd.ms-excel'}); // 注意你的文件类型，我的是excel，需要什么类型文件，对应修改即可
        // IE兼容
        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, fileName);
        } else {
          var a = document.createElement('a');
          a.download = fileName;
          a.href = URL.createObjectURL(blob);
          a.setAttribute('id', 'export');
          document.body.appendChild(a); // 修复firefox中无法触发click， platform 为我本页div 的id， 此处可直接用document.body
          a.click();
          document.getElementById('export').remove();
        }
      }).then(() => {
        this.isLoading = false;
      });
    },
    getTargetLists () {
      const params = {
        ...this.form,
        ...this.outform,
        createTimeStart: new Date(this.form.createTimeStart || '').getTime() || '',
        createTimeEnd: new Date(this.form.createTimeEnd || '').getTime() || '',
        expectedDeliveryDateStart: new Date(this.form.expectedDeliveryDateStart || '').getTime() || '',
        expectedDeliveryDateEnd: new Date(this.form.expectedDeliveryDateEnd || '').getTime() || '',
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
      };

      if (this.sortInfo.orderByProperty && this.sortInfo.orderByType) {
        params.orderBy = [this.sortInfo];
      }

      queryBizOppPageList(params).then(({ body }) => {
        this.targetLists = body?.list || [];

        this.pagination.total = Number(body?.total || 0);
      });
    },
    handleAdvancedSearch () {
      this.isShow = true;
    },
  },
  created () {
    this.handleSearch();
  },
};
</script>
<style scoped lang='scss'>
/deep/ .topTitleContainer {
  height: 60px;
  background: #FFFFFF;
  box-shadow: inset 0px -1px 0px 0px #DFE2E8;
  border-radius: 6px 6px 0px 0px;
  display: flex;
  align-items: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #606266;
  line-height: 20px;
  text-align: left;
  font-style: normal;
}

.title-box {
  color: #303133;
  font-weight: 600;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .icon-box {
    display: flex;
    align-items: center;

    img {
      margin-right: 8px;

      &:hover {
        cursor: pointer;
      }
    }

    i {
      &:hover {
        cursor: pointer;
      }
    }
  }
}

/deep/ .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
  background-color: #409EFF;
  border-color: #409EFF;
}

/deep/.vxe-tools--wrapper {
  display: flex;
  justify-content: space-between;

  &>.el-button {
    margin-left: 0.5em;
  }

  &>div.el-input {
    margin-left: 0.5em;
  }

  &>.vxe-button {
    margin-left: 0.5em;
  }
}

/deep/ .vxe-tools--operate {
  &>.vxe-button {
    margin-left: 0.5em;
  }
}

/deep/ .action {
  color: #409EFF;
  cursor: pointer;

  &:hover {
    color: rgba(64, 158, 255, 0.7);
    text-decoration: underline;
  }
}

/deep/ .el-date-editor.el-input {
  width: -webkit-fill-available;
}
</style>
